export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10372.9b3a1450.jpg";